export default "__VITE_ASSET__mjOOtFJs__"